import $ from 'jquery';
import { View, Model } from 'backbone';
import util from 'util/Util.js';
import template from 'dashboard/forms/form-instances.ejs';
import NotificationService from 'NotificationService.js';
import RestService from 'RestService.js';
import constants from 'Constants.js';
import eventBus from 'EventBus.js';
import PlayFormModal from 'common-views/PlayFormModal.js';
import DeleteModal from 'dashboard/forms/modal/FormDeleteModal.js';
import DataHistoryModal     from 'common-views/DataHistoryModal.js'; 
import mapVersionsModal from 'dashboard/forms/modal/MapVersionsModal.js';
import dashboardService from 'DashboardService';
import MigrateFormInstanceModal     from 'dashboard/forms/modal/MigrateFormInstanceModal.js';
import restMessages from 'RestMessages';

class FormInstancesView extends View {
    initialize(opts) {
        super.initialize(opts);

        this.options = opts || {};
        this.template = template;
        this.gridElement = '#formInstancesGrid';
        this.closed = opts.closed;

        this.requiresHigherAttentionLevel = ['1.5', '2.5', '3.5', '4.5'];

        this.events = {
            'change select': 'updateAttributes',
            'change input[type="text"]': 'updateAttributes',
            'click #btnDetails': 'handleClickDetails',
            'click #btnView': 'handleClickView',
            'click #btnDelete': 'handleClickDelete',
            'click #btnDataHistory': 'dataHistory',
            'click #goToForms': 'goToForms',
            'click #goToEditForms': 'goToEditForms',
            'click #btnMapVersions': 'showMapVersions',
            'click #btnMigrate': 'btnMigrate',
            'click #nextPage': 'nextPage',
            'click #previousPage': 'previousPage',
            'click #firstPage': 'firstPage',
            'click #lastPage': 'lastPage',
            'click #btnClearLock': 'clearLock'
        };

        this.listenTo(this.model, 'change', this.render);
        this.model.set('currentPage', 1, { silent: true });

        return this;
    }

    btnMigrate(ev){
        ev.preventDefault();
        const formInstanceId = this.model.get('instanceId');
        if(!formInstanceId){
            return;
        }
        const form = this.model.get('formList').filter(form => form.id === formInstanceId );
        const name = form[0].name + ' (' + util.formatExpressionShortDate(form[0].lastSubmission) + ')';
        let mfiModal = new MigrateFormInstanceModal();
        mfiModal.render().then((type) => {
            if (type && type !== '') {
                RestService.exportFormResponseData(formInstanceId, type, name);
            }
        }).catch(err => console.log(err));
    }

    lastPage(ev){
        ev.preventDefault();
        this.model.set('currentPage',  this.model.get('totalPages'), { silent: true });
        $(this.gridElement).jqGrid('GridUnload');
        this.findInstances(this.getFilter());
        $('#lastPage').addClass("disable_a_href");
        $('#nextPage').addClass("disable_a_href");
        $('#firstPage').removeClass("disable_a_href");
        $('#previousPage').removeClass("disable_a_href"); 
    }

    firstPage(ev){
        ev.preventDefault();
        this.model.set('currentPage',  1, { silent: true });
        $(this.gridElement).jqGrid('GridUnload');
        this.findInstances(this.getFilter());
        $('#firstPage').addClass("disable_a_href");
        $('#previousPage').addClass("disable_a_href");
        $('#lastPage').removeClass("disable_a_href");
        $('#nextPage').removeClass("disable_a_href"); 
    }

    nextPage(ev){
        ev.preventDefault();
        this.model.set('currentPage', this.model.get('currentPage') + 1, { silent: true });
        $(this.gridElement).jqGrid('GridUnload');
        this.findInstances(this.getFilter());
        if(this.model.get('currentPage') === this.model.get('totalPages')){
            $('#lastPage').addClass("disable_a_href");
            $('#nextPage').addClass("disable_a_href");
        }
        $('#firstPage').removeClass("disable_a_href");
        $('#previousPage').removeClass("disable_a_href");  
    }

    previousPage(ev){
        ev.preventDefault();
        this.model.set('currentPage', this.model.get('currentPage') - 1, { silent: true });
        $(this.gridElement).jqGrid('GridUnload');
        this.findInstances(this.getFilter());
        if(this.model.get('currentPage') === 1){
            $('#firstPage').addClass("disable_a_href");
            $('#previousPage').addClass("disable_a_href"); 
        }
        $('#lastPage').removeClass("disable_a_href");
        $('#nextPage').removeClass("disable_a_href");  
    }
    
    dataHistory(ev) {  
        const formInstanceId = this.model.get('instanceId');
        if(!formInstanceId){
            return;
        }
        const form = this.model.get('formList').filter(form => form.id === formInstanceId );
        const firstDate = util.formatExpressionShortDate(form[0].firstSubmission);
        RestService.getFormDataHistory(formInstanceId).then((data)=>{
            const attributes = {subtitle:'Data History - ' + form[0].name + ' (' + firstDate + ')' , 
                                dataHistory: data};
            let newDatahistoryForm = new DataHistoryModal({model: new Model(attributes) });
            newDatahistoryForm.render().then((result)=>{
            }).catch((err)=> {
                console.log('Error in Data History', err);
            });
        });
    }

    updateAttributes(event) {
        let targetName = event.target.name;
        let targetValue = event.target.value;
        this.model.set(targetName, targetValue);
    }

    // Finds all instances depending on filter parameter    
    findInstances(filter) {
        // Load data
        util.disableReloadLink();
        RestService.searchFormInstances(filter).then((response) => {
            util.enableReloadLink();
            let formList = [];
            let totalInstances = 0;
            let totalPages = 0;

            if (response.RESULT.RESPONSE.InstanceList && response.RESULT.RESPONSE.InstanceList.Instance) {
                if (!(response.RESULT.RESPONSE.InstanceList.Instance instanceof Array)) {
                    response.RESULT.RESPONSE.InstanceList.Instance = [response.RESULT.RESPONSE.InstanceList.Instance];
                }

                totalInstances = Number(response.RESULT.RESPONSE.TotalRecords);
                if (totalInstances > 100){
                    totalPages = Math.ceil (totalInstances/100);
                }

                formList = response.RESULT.RESPONSE.InstanceList.Instance.map(instance => {
                    return {
                        id: instance['@Id'],
                        formInstanceId: instance["@FormInstanceId"],
                        name: instance['@Name'],
                        attentionLevel: util.getAttentionLevel(instance['@AttentionLevel']),
                        stage: instance["@StageName"],
                        status: instance["@IsClosed"] === 'False' ? 'Open' : 'Closed',
                        firstSubmission: instance['@FirstSubmissionDate'],
                        lastSubmission: instance['@LastSubmissionDate'],
                        isDraft: instance["@IsDraft"]
                    }
                });
            }

            if (totalInstances > 100){
                $('#instancesCount', this.$el).text(formList.length + ' of '+ totalInstances +' App Instances'); 
                $('#pagination', this.$el).text('Page '+ this.model.get('currentPage')+ ' of '+ totalPages);
            }else{
                $('#instancesCount', this.$el).text(formList.length + ' App Instances');
                $('#pager').css('display', 'none');
             }

            this.model.set('formList', formList, { silent: true });
            this.model.set('totalInstances', totalInstances, { silent: true });
            this.model.set('totalPages', totalPages, { silent: true });

            this.renderGrid(formList);


        }).catch(err => {
            util.enableReloadLink();            
            let errMsg = restMessages.codeToMessage(err.CODE);
            console.log(errMsg + '. ' + err);
            NotificationService.error('Error Search App Instances Data. ' + errMsg);
        });
    }

    // Composes filter
    getFilter() {
        let attentionLevel = this.model.get('attentionLevel') || -1;
        let attentionLevelOrHigher = this.requiresHigherAttentionLevel.indexOf(attentionLevel.toString() || -1) !== -1;
        let currentPage = this.model.get('currentPage');
        let startIndex =  (currentPage-1)*100+1;

        //Replaces the wildcard from * to % which is the one used in the web service
        let name = this.model.get('instanceName') ? this.model.get('instanceName').split('*').join('%') : '';

        //Always add the wildcard at the end to get the same functionality as flash
        name += "%";

        if (attentionLevelOrHigher) {
            attentionLevel -= 0.5;
        }
        return {
            startIndex:startIndex,
            status: this.model.get('status') || -1,
            name: name || '',
            attentionLevel: attentionLevel,
            attentionLevelOrHigher: attentionLevelOrHigher,
            version: this.model.get('version') || 0,
            formsXML: `&lt;Forms&gt;&lt;Form id="${this.model.get('formId')}"/&gt;&lt;/Forms&gt;`
        };

    }

    // Creates a jqgrid element
    renderGrid(data) {
        $(this.gridElement).jqGrid({
            data: data,
            autowidth: true,
            shrinkToFit: true,
            rowList: [5, 10, 20, "10000:All"],
            viewrecords: true,
            multiselect: true,
            altRows: true,   
            altclass: "jqGrid-alt-row",
         
           gridComplete: () => {
                $(this.gridElement + " [aria-describedby*='isDraft']").each( (index, value) => {
                    if(util.isTrue(value.innerText)){
                        value.parentElement.style.fontStyle = "italic";
                    }                   
                });

                $(this.gridElement).hideCol("cb");
            },
            colNames: ['Name', 'Stage', 'Status','Attention Level', 'First Submission', 'Last Submission', 'isDraft', 'formInstanceId'],
            colModel: [
                { name: 'name', index: 'name' },
                { name: 'stage', index: 'stage' },
                { name: 'status', index: 'status' },
                { name: 'attentionLevel', index: 'attentionLevel' },
                // PF-9593 Form instances display the same inaccurate submission time across multiple instances
                // Changed date format for minutes (i = minutes)
                { name: 'firstSubmission', index: 'firstSubmission', sorttype: 'date', formatter: 'date',  formatoptions: {srcformat: 'ISO8601Long', newformat: 'd M Y H:i'} },
                { name: 'lastSubmission', index: 'lastSubmission', sorttype: 'date', formatter: 'date',  formatoptions: {srcformat: 'ISO8601Long', newformat: 'd M Y H:i'} },
                { name: 'isDraft', index: 'isDraft', hidden: true },
                { name: 'formInstanceId', index: 'formInstanceId', hidden: true }
            ],
            beforeSelectRow: (rowid, e) => {

                // clear text selection
                if (document.selection && document.selection.empty) {
                    document.selection.empty();
                } else if (window.getSelection) {
                    window.getSelection().removeAllRanges();
                }

                let grid = this.gridElement;

                const $this = $(grid),
                startId = $this.getGridParam('selrow');

                if (!e.ctrlKey && !e.shiftKey) {
                    $this.resetSelection();
                } else if (e.shiftKey) {                 
                    $this.resetSelection();
                    const startRow = $this.getInd(startId);
                    const endRow = $this.getInd(rowid);

                    if (startRow && endRow) {
                        let startID = Math.min(startRow, endRow);
                        let endID = Math.max(startRow, endRow);

                        $.each($this.getDataIDs(), (i, id) => {
                            let index = $this.getInd(id);
                            if (index >= startID && index < endID) {
                                $this.setSelection(id, false);
                            }
                        });
                    }                    
                }
                return true;
            },
            onSelectRow: (rowId) => {

                const selected = $(this.gridElement).getGridParam('selarrrow');                
              
                if(selected.length === 1){
                    let rowData = this.model.get('formList').filter(item => {
                        return item.id === rowId;
                    })[0];

                    this.model.set({
                        formInstanceId: rowData.formInstanceId,
                        instanceId: rowData.id,
                        isDraft: util.isTrue(rowData.isDraft)
                    }, { silent: true });
                }
                else{
                    this.model.set("instanceId", selected, { silent: true });
                }

                $("#btnDetails, #btnView, #btnDataHistory, #btnMigrate, #btnClearLock").prop('disabled', selected.length !== 1);
                $("#btnDelete").prop('disabled', false);
            }
        }).jqGrid("gridResize");
    }

    // Resize jqgrid - hack
    resizeGrid() {
        let grid = $('.ui-jqgrid-btable', this.$el);
        if (grid) {
            grid.each(function (index) {
                let gridId = $(this).attr('id');
                let gridParentWidth = $('#gbox_' + gridId).parent().width();
                $('#' + gridId).setGridWidth(gridParentWidth);
            });
        }
    }

    // Opens the details of a form    
    handleClickDetails(ev) {
        ev.preventDefault();

        let instanceId = this.model.get('instanceId');
        let formInstanceId = this.model.get('formInstanceId');

        // PF-9866 Dashboard - App instance details screen is showing invalid/undefined data (scenario)
        // If instanceId is an array, get the first element and use it as the selected instance
        if (Array.isArray(instanceId)) {
            instanceId = instanceId[0];
            this.model.set('instanceId', instanceId, {silent: true});
        }

        eventBus.trigger('viewFormDetails', instanceId, formInstanceId)
    }

    // Opens a popup with the instance of the form
    handleClickView(ev) {
        let instanceUrl = RestService.getLinkUrl(this.model.get('formInstanceId')) + '&viewForm=true';
        const isDraft = this.model.get('isDraft');
        if (isDraft){
            instanceUrl += '&isDraft=1';
        }
        const attributes = { url: instanceUrl, id: this.model.get('formInstanceId') };
        const newPlayForm = new PlayFormModal({ model: new Model(attributes) });
        newPlayForm.render().then((result) => { });
    }

    // Deletes a form instance    
    handleClickDelete(ev) {
        ev.preventDefault();

        if (!Array.isArray(this.model.get('instanceId'))) {
            this.model.set('instanceId', [this.model.get('instanceId')], { silent: true });
        }
        //_.each(this.model.get('instanceId'), (instance) => {
            dashboardService.deleteInstance(this.model.get('instanceId'), true, this.model.get('formList'));
        //});
    }

    showMapVersions(ev){
        const formId = this.model.get('formId');
        if (formId && formId !== '') {
            RestService.getFormVersionsMapping(formId).then(versionList => {
                let gridData = [];
                $.each(versionList.VersionList.Version, (_idx, _item) => {
                    let _MapMajorVersion = _item['@MapMajorVersion'] === '' ? '0.01' : Number(_item['@MapMajorVersion']).toFixed(2);
                    gridData.push({ FormVersionId: _item['@FormVersionId'], MajorVersion: Number(_item['@MajorVersion']).toFixed(2), MapMajorVersion: _MapMajorVersion });
                });

                //sort descending by major version
                gridData.sort(function (a, b) {
                    return parseInt(b.MajorVersion) - parseInt(a.MajorVersion);
                });

                let mvModal = new mapVersionsModal({ model: new Model({ formId: formId, gridData: gridData }) });
                mvModal.render().then((versionList) => {
                    if (versionList && versionList.VersionList && versionList.VersionList.Version && versionList.VersionList.Version.length > 0) {
                        RestService.updateFormVersionsMapping(formId, versionList).catch((err) => {
                            let errMsg = restMessages.codeToMessage(err.CODE);
                            console.log(errMsg + '. ' + err);
                            NotificationService.error('Error Mapping Versions. ' + errMsg);
            
                            return (err);
                        });
                    }
                }).catch(err => console.log(err));                
            }).catch((error) => {
                var msg = error || 'Unknown Error';
                console.log('error ', error);
                return (error);
            });
        }
    }

    render() {
        super.render();

        this.$el.empty();
        this.$el.html(this.template(this.model.toJSON()));

        // Select values for filter form
        $('#status', this.$el).val(this.model.get('status') || -1);
        $('#instanceName', this.$el).val(this.model.get('instanceName') );
        $('#attentionLevel', this.$el).val(this.model.get('attentionLevel') || -1);
        $('#version', this.$el).val(this.model.get('version') || 0);

        // Load data        
        this.findInstances(this.getFilter());   

        // Dirty hack
        $(window).on('resize', this.resizeGrid.bind(this));

        // Disable buttons        
        $(".actions button").prop('disabled', true);

        this.delegateEvents();

        return this;
    }

    remove() {
        $(window).off('resize', this.resizeGrid.bind(this));
        super.remove();
    }

    goToForms(e) {
         e.preventDefault();
         e.stopPropagation();
 
         eventBus.trigger("loadFormsView");
     }
 
    goToEditForms(e) {
         e.preventDefault();
         e.stopPropagation();
 
         eventBus.trigger("displayDefaultEditFormsDetailView");        
    }

    clearLock(ev){
        RestService.clearLock(this.model.get('formInstanceId'));
    }
}

export default FormInstancesView;